<div class="row w-100">

  <container-element [ngSwitch]="input.QueovalCode" class="col">

    <!--TEXTAREA-->
    <ng-container *ngSwitchCase="'TEXTAREA'">
      <div class="row">
        <div class="col-8">
          <textarea [id]="getId(input)" class="w-100 q-input-no-border q-bo-wrap" [ngClass]="{'q-input-required' : input.MainElementList[0].Required}" [style.Height.px]="input.MainElementList[0].Height"
                    [(ngModel)]="input.MainElementList[0].Value" wrap="hard" rows="2">{{input.MainElementList[0].Value}}</textarea>
        </div>
        <ng-container *ngTemplateOutlet="templateFilter"></ng-container>
      </div>
    </ng-container>
    <!--COMBO-->
    <ng-container *ngSwitchCase="'COMBO'">
      <div class="row">
        <div class="col-8">
          <select [id]="getId(input)" class="q-main-select q-bo-select q-bo-wrap" [ngClass]="{'q-input-required' : input.MainElementList[0].Required}" (change)="selectChange($event.target.value)">
            <option *ngFor="let option of input.MainElementList[0].SelectOptionsList" [title]="option.Tooltip" [value]="option.Value" [selected]="option.Value==input.MainElementList[0].Value">{{option.Text}}</option>
          </select>
        </div>
        <ng-container *ngTemplateOutlet="templateFilter"></ng-container>
      </div>
    </ng-container>
    <!--CHECKBOX-->
    <ng-container *ngSwitchCase="'CHECKBOX'">
      <div class="row">
        <div class="col-8">
          <select [id]="getId(input)" class="q-main-select q-bo-select q-bo-wrap " [ngClass]="{'q-input-required' : input.MainElementList[0].Required}" (change)="selectChange($event.target.value)">
            <option *ngFor="let filter of input.FilterBo" [value]="filter.key" [selected]="filter.key==input.MainElementList[0].Value">{{filter.value}}</option>
          </select>
        </div>
      </div>
    </ng-container>

    <!--DATE-->
    <ng-container *ngSwitchCase="'DATE'">
      <ng-container *ngTemplateOutlet="sharedTemplateDATE"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'DTAGENDA'">
      <ng-container *ngTemplateOutlet="sharedTemplateDATE"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'DTQHARH'">
      <ng-container *ngTemplateOutlet="sharedTemplateDATE"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'DTHEUMIN'">
      <ng-container *ngTemplateOutlet="sharedTemplateDATE"></ng-container>
    </ng-container>
   
    <ng-template #sharedTemplateDATE>
      <div class="row">
        <div class="q-bo-wrap col-8">
          <q-date [ngValue]="setDate(input.MainElementList[0])" (ngValueChange)="DateChange($event)" [ngClass]="{'q-input-required' : input.MainElementList[0].Required}"></q-date>
        </div>
        <select class="q-main-select q-bo-select col-4" [ngClass]="{'q-input-required' : input.MainElementList[0].Required}" (change)="selectFilter($event.target.value)">
          <option *ngFor="let filter of input.FilterBo" [value]="filter.key" [selected]="filter.key==input.MainElementList[0].Filter">{{filter.value}}</option>
        </select>
      </div>

      <div class="row mt-2">
        <div class="q-bo-wrap col-8">
          <q-date [ngValue]="setDate(input.MainElementList[1])" (ngValueChange)="DateChange($event,1)" [ngClass]="{'q-input-required' : input.MainElementList[1].Required}"></q-date>
        </div>
        <select class="q-main-select q-bo-select col-4" [ngClass]="{'q-input-required' : input.MainElementList[1].Required}" (change)="selectFilter($event.target.value,1)">
          <option *ngFor="let filter of input.FilterBo" [value]="filter.key" [selected]="filter.key==input.MainElementList[1].Filter">{{filter.value}}</option>
        </select>
      </div>
    </ng-template>

    <!--CPVILLE-->
    <ng-container *ngSwitchCase="'CPVILLE'">
      <div class="row">
        <div class="col-8">
          <q-codepostal [input]="input"></q-codepostal>
        </div>
        <ng-container *ngTemplateOutlet="templateFilter"></ng-container>
      </div>
    </ng-container>

    <!--RADIOBUT-->
    <ng-container *ngSwitchCase="'RADIOBUT'">
      <div class="row">
        <div class="col-8">
          <ng-container [ngSwitch]="input.MainElementList[0].Mask">
            <ng-container *ngSwitchCase="'CABINET'">
              <select [id]="getId(input)" class="q-main-select q-bo-select q-bo-wrap" [ngClass]="{'q-input-required' : input.MainElementList[0].Required}" (change)="selectChange($event.target.value)">
                <option *ngFor="let option of input.MainElementList[0].SelectOptionsList" [title]="option.Tooltip" [value]="option.Value" [selected]="option.Value==input.MainElementList[0].Value">{{option.Text}}</option>
              </select>
              <!--<q-cabinet [input]="input"></q-cabinet>-->
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input [id]="getId(input)" [attr.type]="input.MainElementList[0].Type" class="q-bo-input q-bo-input-only q-bo-wrap " [ngClass]="{'q-input-required' : input.MainElementList[0].Required}" [(ngModel)]="input.MainElementList[0].Value">
            </ng-container>
          </ng-container>

        </div>
        <ng-container *ngTemplateOutlet="templateFilter"></ng-container>
      </div>
    </ng-container>

    <!--Default-->
    <ng-container *ngSwitchDefault>
      <div class="row">
        <div class="col-8">
          <input [id]="getId(input)" [attr.type]="input.MainElementList[0].Type" class="q-bo-input q-bo-input-only q-bo-wrap " [ngClass]="{'q-input-required' : input.MainElementList[0].Required}" [(ngModel)]="input.MainElementList[0].Value">
        </div>
        <ng-container *ngTemplateOutlet="templateFilter"></ng-container>
      </div>
    </ng-container>
  </container-element>
</div>


<ng-template #templateFilter>
  <select class="q-main-select q-bo-select col-4" [ngClass]="{'q-input-required' : input.MainElementList[0].Required}" (change)="selectFilter($event.target.value)">
    <option *ngFor="let filter of input.FilterBo" [value]="filter.key" [selected]="filter.key==input.MainElementList[0].Filter">{{filter.value}}</option>
  </select>
</ng-template>
